export enum SpinnerTypes {
  DARK = 'dark',
  LIGHT = 'light'
}
